import template from './manage-subscriptions.html';

class ManageSubscriptionsVM
{
	constructor(page)
	{
		this.page = page;
		this.subscriptions = ko.observableArray([]);
		this.loading = ko.observable(false);
	}

	navigateToSubscription(data)
	{
		window.location.hash = `/ui/events/subscription/${data.subscription_uuid}`;
	}

	btnCreateNew()
	{
		window.location.hash = '/ui/events/subscription/new';
	}

	async btnDeleteSubscription(data, event)
	{
		if (event)
			event.stopPropagation();

		const confirmed = await Grape.alerts.confirm({
			type: 'warning',
			title: 'Delete Subscription',
			message: `Delete this subscription (${data.event_namespace}.${data.event_object_type}.${data.event_name} → ${data.action_namespace}.${data.action_name})?`
		});
		if (!confirmed)
			return;

		try
		{
			const result = await Grape.fetches.postJSON('/api/subscription/delete', {
				subscription_uuid: data.subscription_uuid
			});
			if (result)
				this.page.updateData();
		}
		catch (err)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		}
	}

	formatDate(dateStr)
	{
		if (!dateStr)
			return '-';
		return moment(dateStr).format('YYYY-MM-DD HH:mm');
	}
}

class ManageSubscriptionsPage
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ManageSubscriptionsVM(this);
		this.name = 'ManageSubscriptionsPage';
	}

	async init()
	{
		document.title = 'Event Subscriptions';
	}

	async updateData()
	{
		this.viewModel.loading(true);
		try
		{
			const result = await Grape.fetches.getJSON('/api/record', {
				schema: 'events',
				table: 'v_subscription_detail',
				sortfield: 'idx',
				sortorder: 'ASC',
				fields: [
					'subscription_uuid',
					'event_namespace',
					'event_name',
					'event_object_type',
					'action_namespace',
					'action_name',
					'active',
					'defer',
					'idx',
					'event_data_match',
					'action_count_7d',
					'action_count_30d',
					'map_namespace',
					'map_name',
					'last_executed'
				]
			});

			if (result.status !== 'ERROR')
				this.viewModel.subscriptions(result.records || []);
			else
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'Failed to load subscriptions' });
		}
		catch (err)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		}
		finally
		{
			this.viewModel.loading(false);
		}
	}
}

export default {
	route: '[/]ui/events/subscriptions',
	page_class: ManageSubscriptionsPage,
	template: template
};
